var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scatter-chart',{attrs:{"height":400,"chart-data":_vm.data,"options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }